module.exports = __webpack_public_path__ + "img/deathless-divide.3a8df267.png";